import i18n from 'i18n-js';
import { SET_SHIPMENT_STATE } from '../constants';
import {
  isShippingEasyOrder,
  openShippingEasyUrl
} from '../components/ScanpackScanning/utils/postScanHandlers';
import { fetchShipmentData } from '../services/scanpackApiService';
import { SearchScanpackOrder } from './scanpackAction';

export function handleShippingEasyShipment(apiOrder, scanPackSettings) {
  return async (dispatch) => {
    if (!isShippingEasyOrder(apiOrder, scanPackSettings)) return;

    if (apiOrder?.shipment_id) {
      openShippingEasyUrl(apiOrder.shipment_id);
      return;
    }

    try {
      const res = await fetchShipmentData(apiOrder?.store_id, apiOrder?.id);
      const shipmentData = res?.data;

      if (shipmentData?.shipment_id) {
        openShippingEasyUrl(shipmentData.shipment_id);
      } else if (
        shipmentData?.se_all_shipments ||
        shipmentData?.se_old_combined_shipments ||
        shipmentData?.se_old_split_shipments
      ) {
        dispatch({
          type: SET_SHIPMENT_STATE,
          payload: { visible: true, data: shipmentData, errorMessage: '', errorMessageShow: false }
        });
      } else {
        dispatch({
          type: SET_SHIPMENT_STATE,
          payload: {
            visible: true,
            data: null,
            errorMessage: i18n.t('scanpackItem.Scanpack_Item_Shipment'),
            errorMessageShow: true
          }
        });
      }
    } catch {
      dispatch({
        type: SET_SHIPMENT_STATE,
        payload: {
          visible: true,
          data: null,
          errorMessage: i18n.t('scanpackItem.Scanpack_Item_Shipment'),
          errorMessageShow: true
        }
      });
    }
  };
}

export function hideShipment() {
  return (dispatch) => {
    dispatch({
      type: SET_SHIPMENT_STATE,
      payload: { visible: false, data: null, errorMessage: '', errorMessageShow: false }
    });
  };
}

export function callShipmentOrder(order) {
  return (dispatch) => {
    if (!order?.increment_id) return;
    dispatch(hideShipment());
    dispatch(SearchScanpackOrder(order.increment_id, false));
  };
}
